import { render } from "./PanelRelatedItems.vue?vue&type=template&id=d6229912&scoped=true&ts=true"
import script from "./PanelRelatedItems.vue?vue&type=script&lang=ts"
export * from "./PanelRelatedItems.vue?vue&type=script&lang=ts"

import "./PanelRelatedItems.vue?vue&type=style&index=0&id=d6229912&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6229912"]])

export default __exports__